/** The clear Graph in the Builder (ADR-0071): step boxes, arrows, the step panel, code. */
export default {
  en: {
    badge: {
      python: "Python code",
      browser: "Web browser",
      ai: "AI model",
      knowledge: "Search knowledge",
      person: "Ask a person",
      approval: "Approval",
      decision: "Choose a path · AI",
      subagent: "Sub-agent",
      teamMember: "Team member",
      supervisor: "Supervisor · AI",
      choose: "Choose a path · rule",
      parallel: "Several at once",
      join: "Wait for all",
      code: "Built-in code",
      system: "Connected system",
      wait: "Waits",
      calc: "Calculate",
      loop: "For each item",
      table: "Table",
      handover: "Hand over to a person",
      finish: "Finish",
    },
    legend: {
      label: "How to read the graph",
      normal: "normal path, labelled with the data passed on",
      fallback: "“if it didn’t work”",
      choice: "a choice between paths",
      uses: "what the step uses",
    },
    node: {
      aria: "Step {{n}}: {{name}}, {{badge}}. {{what}}",
      uses: "uses",
      makes: "makes",
      nothing: "nothing new",
      finish: "Finish",
      finishAria: "Finish: the answer is shown",
      finishLine: "Finish · the answer is shown",
      issues: "needs attention",
      answerFrom: "The answer from ‘{{step}}’",
      codeMakes: "What its code returns",
      replyNotKept: "The reply (not kept)",
      joinMakes: "What the side-by-side steps made",
    },
    delete: {
      title: "Delete ‘{{step}}’?",
      text: "‘{{step}}’ is between ‘{{from}}’ and ‘{{to}}’. Connect ‘{{from}}’ straight to ‘{{to}}’ so the run still gets there, or just delete the step and its arrows.",
      reconnect: "Delete and connect to ‘{{to}}’",
      only: "Just delete",
      cancel: "Keep it",
    },
    leave: {
      title: "Leave without saving?",
      text: "Your changes in the advanced editor aren't saved and will be lost if you go back to the guided flow now.",
      ok: "Go back and lose them",
      cancel: "Stay here",
    },
    arrow: {
      duplicate: "There is already an arrow from ‘{{from}}’ to ‘{{to}}’ — it is selected so you can change it.",
      retargetDuplicate: "There is already an arrow from ‘{{from}}’ to ‘{{to}}’, so this arrow can’t go there too.",
      retargetSelf: "An arrow can’t lead back into the step it leaves (‘{{from}}’).",
      goesTo: "Goes to",
      goesToHelp: "The step this arrow leads to. Its condition and label stay. You can also drag the arrow’s end onto another step.",
      close: "Close the message",
    },
    action: {
      runFile: "Runs {{file}} in mode ‘{{mode}}’",
      runFileNoMode: "Runs {{file}}",
      runCode: "Runs a short Python program",
      openPages: "Opens the pages from ‘{{step}}’ and reads them with {{script}}",
      openPagesPlain: "Opens the pages from ‘{{step}}’ and reads them",
      openPagesAny: "Opens web pages and reads them",
      useSystem: "Uses {{tool}}: {{action}}",
      useSystemMissing: "Uses “{{tool}}”, which isn't connected",
      askAiLibrary: "Asks the AI model, with a prompt from the prompt library",
      askAiWritten: "Asks the AI model, with the prompt written in this step",
      search: "Searches the knowledge collection ‘{{collection}}’",
      askPerson: "Asks a person a question and waits for the answer",
      approval: "Waits until a person approves",
      approvalFrom: "Waits until a person approves what ‘{{step}}’ made",
      decide: "Picks one of {{count}} options with the decision model",
      subagent: "Runs another agent: {{agent}}",
      choose: "Chooses the next step by the conditions on its arrows",
      parallel: "Runs {{count}} steps side by side",
      join: "Brings the results of the side-by-side steps together",
      code: "Runs built-in code: {{entrypoint}}",
      calc: "Works out values without AI ({{count}})",
      foreach: "Does the same for each item of a list",
      table: "Works with a table",
      finish: "Ends the run; the answer is shown",
      handover: "Hands the conversation to a person on the team",
    },
    panel: {
      step: "Step {{n}}",
      whatItDoes: "What it does",
      receives: "It receives",
      makes: "It makes",
      then: "Then",
      limits: "Limits and technical settings",
      edit: "Change this step",
      viewCode: "View code",
      hideCode: "Hide code",
      noInputs: "Nothing from earlier steps.",
      fromStep: "step {{n}} · {{value}}",
      fromStart: "{{value}}",
      fromUnknown: "the request (‘{{path}}’)",
      setHere: "set here: {{value}}",
      makesNothing: "Nothing that later steps use.",
      exampleFromRun: "From the last test run: {{example}}",
      shapeFields: "Fields: {{fields}}",
      next: "Step {{n}} · {{step}}",
      nextFinish: "Finish · the answer is shown",
      nextNone: "Nothing; the run ends here.",
      fallback: "If {{when}} → step {{n}} · {{step}}",
      fallbackFinish: "If {{when}} → finish",
      choice: "{{when}} → step {{n}} · {{step}}",
      choiceFinish: "{{when}} → finish",
      otherwise: "otherwise",
      it: "it didn't work",
      keyValues: "Key settings",
    },
    key: {
      mode: "Mode",
      file: "Program",
      script: "Page script",
      output: "Result format",
      collection: "Knowledge collection",
      agent: "Other agent",
    },
    limit: {
      timeout_s: "Time limit",
      script_timeout_s: "Time limit per page",
      memory_mb: "Memory",
      internet: "Internet",
      output: "Result format",
      changes_data: "Changes data",
      max_iterations: "Repeat at most",
      output_key: "Saved as",
      output_field: "Keeps the field",
      seconds: "{{n}} s",
      mb: "{{n}} MB",
      none: "none",
      yes: "yes",
      no: "no",
      times: "{{n}} times",
    },
    shape: {
      field: "Field {{n}}",
      name: "Field name",
      type: "Kind of data",
      description: "What it is",
      known: "Values it can take",
      remove: "Remove field {{n}}",
      add: "Add a field",
      closed: "Only these fields",
      help: "Later steps get these fields in their pickers; with “Only these fields”, a mistyped field is flagged.",
      plainName: "Plain name",
      plainEn: "Plain name (English)",
      plainAr: "Plain name (Arabic)",
      codeName: "Name in code",
      edit: "Edit {{field}}",
      done: "Done",
      anyValue: "any value",
      mayBeEmpty: "May be empty",
      required: "Always given (the AI can't leave it out)",
      requiredTag: "always given",
      internal: "Internal (bookkeeping, folded in Read)",
      internalGroup: "Internal fields ({{count}})",
      fromRun: "Fill from the last test run",
    },
    fields: {
      outputField: "Keep only this field of the result",
      outputFieldHelp: "Leave empty to keep the whole result.",
      makes: "What it makes",
      makesHelp: "Declare the fields this step makes (or use a test run's value), so later steps can pick them.",
      outputFormat: "Output format",
      outputFormatHelp: "Ask the AI model for these fields instead of free text; later steps can then use each field.",
      prompt: "What to ask the AI model",
      query: "What to search for",
      subject: "What the approver sees",
      subjectPreview: "The approver sees: {{fields}}",
      answerType: "Kind of answer",
      answer: { text: "Text", number: "A number", yes_no: "Yes or no", choice: "One of a list" },
      choices: "The choices",
      inputs: "What the other agent gets",
      inputName: "Its input",
      inputValue: "Value from this agent",
      addInput: "Add an input",
      input: "What the decision model reads",
      sample: "What the event looks like",
      sampleHelp: "Paste a sample event (JSON). Its fields become available to the steps as “The event that started it”.",
      sampleInvalid: "This is not valid JSON.",
      sampleFields: "Fields the steps can use",
      checks: "Checks on the answer's fields",
      checksHelp: "Each check must hold on the agent's final data, e.g. the answer's status is ok.",
      addCheck: "Add a check",
      approvalRules: "When approval rules apply",
      prompts: "Values you can use",
      promptsAgent: "Values from an agent",
    },
    wizard: {
      amountField: "Which value is the amount?",
      amountFieldHelp: "The approval threshold compares this value. Pick the amount the AI sends to the action.",
      amountRequest: "The “amount” the AI sends to the action",
      amountArg: "The “{{name}}” the AI sends to “{{action}}”",
    },
    run: {
      seeData: "See what passed through each step",
      show: "Show data from the test run",
      title: "From your test run",
      help: "What passed through each step of your test run: personal data is masked, long values are shortened, and it is kept for {{hours}} hours. Your viewing is recorded.",
      passed: "What passed through (test run)",
      made: "What it made in the test run",
      sent: "What it was sent in the test run",
      none: "Nothing passed here in the test run.",
      masked: "personal data masked",
      truncated: "shortened",
      useShape: "Use this as the step's shape",
      unavailable: "The test run's data can't be shown (only your own test runs in development, for a limited time).",
    },
    data: {
      maybe: "may be empty",
      none: "Nothing here yet",
      typePath: "No match. Press Enter to use what you typed.",
      pick: "Choose a value from earlier steps",
      insert: "Insert a value",
      insertFor: "Insert a value from earlier steps into {{field}}",
      plainPreview: "With plain names",
      unknownValue: "not available here",
      hint: {
        mustache: "Type {{ to insert a value from earlier steps.",
        brace: "Type { to insert one of the step's values.",
        state: "Type state. to insert a value from earlier steps.",
        prompt: "Type {{ to insert one of the agent's values.",
      },
      type: { string: "text", number: "a number", integer: "a whole number", boolean: "yes or no", array: "a list", object: "a group of fields", null: "empty", any: "anything", date: "a date", money: "an amount of money" },
      fromStep: "step {{n}} · {{step}}",
      fromStart: "the request",
      eachItem: "each item",
      checks: "Data checks",
      preview: "In plain words: {{text}}",
      arrowLabel: "Name of the arrow ({{lang}})",
      arrowLabelHelp: "Plain words shown on the arrow, e.g. “city not understood”.",
      show: "Show the step",
      saveBlocked: "This version refers to data that doesn't exist",
      savedWithProblems: "Saved as a draft. Fix the data problems before you submit it.",
    },
    code: {
      title: "{{file}}",
      usedBy: "used by {{steps}}",
      usedByOne: "used by {{steps}}",
      notUsed: "not used by any step",
      inline: "written inside this step",
      step: "step {{n}}",
      edit: "Edit",
      done: "Done",
      close: "Close",
      editHelp: "You are editing the agent's file. Every step that uses it gets the change; save the agent to keep it.",
      files: "Agent files",
      filesHelp: "Code stored once for the whole agent; steps use it by name.",
      noFiles: "This agent has no files.",
      size: "{{kb}} KB",
      lines: "{{n}} lines",
      choose: "Show {{file}}",
      usesFile: "Uses the agent file {{files}}",
    },
  },
  ar: {
    badge: {
      python: "كود بايثون",
      browser: "متصفح الويب",
      ai: "نموذج ذكاء اصطناعي",
      knowledge: "بحث في المعرفة",
      person: "سؤال شخص",
      approval: "موافقة",
      decision: "اختيار مسار · ذكاء اصطناعي",
      subagent: "وكيل فرعي",
      teamMember: "عضو في الفريق",
      supervisor: "مشرف · ذكاء اصطناعي",
      choose: "اختيار مسار · قاعدة",
      parallel: "عدة أمور معًا",
      join: "انتظار الكل",
      code: "كود مدمج",
      system: "نظام متصل",
      wait: "ينتظر",
      calc: "حساب",
      loop: "لكل عنصر",
      table: "جدول",
      handover: "التحويل إلى شخص",
      finish: "النهاية",
    },
    legend: {
      label: "كيف تقرأ المخطط",
      normal: "المسار العادي، وعليه اسم البيانات المنقولة",
      fallback: "«إذا لم ينجح»",
      choice: "اختيار بين مسارات",
      uses: "ما تستخدمه الخطوة",
    },
    node: {
      aria: "الخطوة {{n}}: {{name}}، {{badge}}. {{what}}",
      uses: "تستخدم",
      makes: "تُنتج",
      nothing: "لا شيء جديد",
      finish: "النهاية",
      finishAria: "النهاية: تُعرض الإجابة",
      finishLine: "النهاية · تُعرض الإجابة",
      issues: "تحتاج إلى مراجعة",
      answerFrom: "الإجابة من ‘{{step}}’",
      codeMakes: "ما تُرجعه الشيفرة",
      replyNotKept: "الرد (غير محفوظ)",
      joinMakes: "ما أنتجته الخطوات المتوازية",
    },
    delete: {
      title: "حذف ‹{{step}}›؟",
      text: "تقع ‹{{step}}› بين ‹{{from}}› و‹{{to}}›. صِل ‹{{from}}› مباشرة بـ‹{{to}}› ليصل التشغيل إليها كما كان، أو احذف الخطوة وأسهمها فقط.",
      reconnect: "الحذف والوصل بـ‹{{to}}›",
      only: "الحذف فقط",
      cancel: "إبقاؤها",
    },
    leave: {
      title: "المغادرة دون حفظ؟",
      text: "تغييراتك في المحرر المتقدم غير محفوظة وستضيع إذا عدت إلى المسار الموجّه الآن.",
      ok: "العودة وفقدانها",
      cancel: "البقاء هنا",
    },
    arrow: {
      duplicate: "يوجد سهم من ‘{{from}}’ إلى ‘{{to}}’ بالفعل، وقد حُدِّد لتتمكن من تغييره.",
      retargetDuplicate: "يوجد سهم من ‘{{from}}’ إلى ‘{{to}}’ بالفعل، لذا لا يمكن أن يذهب هذا السهم إليها أيضًا.",
      retargetSelf: "لا يمكن أن يعود السهم إلى الخطوة التي يخرج منها (‘{{from}}’).",
      goesTo: "يذهب إلى",
      goesToHelp: "الخطوة التي يقود إليها هذا السهم. يبقى شرطه وتسميته. ويمكنك أيضًا سحب طرف السهم إلى خطوة أخرى.",
      close: "إغلاق الرسالة",
    },
    action: {
      runFile: "يشغّل {{file}} في الوضع ‘{{mode}}’",
      runFileNoMode: "يشغّل {{file}}",
      runCode: "يشغّل برنامج بايثون قصيراً",
      openPages: "يفتح الصفحات من ‘{{step}}’ ويقرؤها باستخدام {{script}}",
      openPagesPlain: "يفتح الصفحات من ‘{{step}}’ ويقرؤها",
      openPagesAny: "يفتح صفحات ويب ويقرؤها",
      useSystem: "يستخدم {{tool}}: {{action}}",
      useSystemMissing: "يستخدم «{{tool}}» وهو غير متصل",
      askAiLibrary: "يسأل نموذج الذكاء الاصطناعي بنص من مكتبة النصوص",
      askAiWritten: "يسأل نموذج الذكاء الاصطناعي بالنص المكتوب في هذه الخطوة",
      search: "يبحث في مجموعة المعرفة ‘{{collection}}’",
      askPerson: "يسأل شخصاً سؤالاً وينتظر الإجابة",
      approval: "ينتظر حتى يوافق شخص",
      approvalFrom: "ينتظر حتى يوافق شخص على ما أنتجته ‘{{step}}’",
      decide: "يختار واحداً من {{count}} خيارات بنموذج القرار",
      subagent: "يشغّل وكيلاً آخر: {{agent}}",
      choose: "يختار الخطوة التالية حسب الشروط على أسهمه",
      parallel: "يشغّل {{count}} خطوات بالتوازي",
      join: "يجمع نتائج الخطوات المتوازية",
      code: "يشغّل كوداً مدمجاً: {{entrypoint}}",
      calc: "يحسب القيم دون ذكاء اصطناعي ({{count}})",
      foreach: "ينفّذ الأمر نفسه لكل عنصر في قائمة",
      table: "يعمل على جدول",
      finish: "ينهي التشغيل وتُعرض الإجابة",
      handover: "يحوّل المحادثة إلى أحد أعضاء الفريق",
    },
    panel: {
      step: "الخطوة {{n}}",
      whatItDoes: "ماذا تفعل",
      receives: "ما تستلمه",
      makes: "ما تُنتجه",
      then: "ثم",
      limits: "الحدود والإعدادات التقنية",
      edit: "تعديل هذه الخطوة",
      viewCode: "عرض الكود",
      hideCode: "إخفاء الكود",
      noInputs: "لا شيء من الخطوات السابقة.",
      fromStep: "الخطوة {{n}} · {{value}}",
      fromStart: "{{value}}",
      fromUnknown: "الطلب (‘{{path}}’)",
      setHere: "محدد هنا: {{value}}",
      makesNothing: "لا شيء تستخدمه الخطوات اللاحقة.",
      exampleFromRun: "من آخر تشغيل تجريبي: {{example}}",
      shapeFields: "الحقول: {{fields}}",
      next: "الخطوة {{n}} · {{step}}",
      nextFinish: "النهاية · تُعرض الإجابة",
      nextNone: "لا شيء؛ ينتهي التشغيل هنا.",
      fallback: "إذا {{when}} ← الخطوة {{n}} · {{step}}",
      fallbackFinish: "إذا {{when}} ← النهاية",
      choice: "{{when}} ← الخطوة {{n}} · {{step}}",
      choiceFinish: "{{when}} ← النهاية",
      otherwise: "غير ذلك",
      it: "لم ينجح",
      keyValues: "الإعدادات الأساسية",
    },
    key: {
      mode: "الوضع",
      file: "البرنامج",
      script: "نص الصفحة البرمجي",
      output: "صيغة النتيجة",
      collection: "مجموعة المعرفة",
      agent: "الوكيل الآخر",
    },
    limit: {
      timeout_s: "الحد الزمني",
      script_timeout_s: "الحد الزمني لكل صفحة",
      memory_mb: "الذاكرة",
      internet: "الإنترنت",
      output: "صيغة النتيجة",
      changes_data: "يغيّر البيانات",
      max_iterations: "التكرار بحد أقصى",
      output_key: "يُحفظ باسم",
      output_field: "يحتفظ بالحقل",
      seconds: "{{n}} ث",
      mb: "{{n}} ميغابايت",
      none: "لا يوجد",
      yes: "نعم",
      no: "لا",
      times: "{{n}} مرات",
    },
    shape: {
      field: "الحقل {{n}}",
      name: "اسم الحقل",
      type: "نوع البيانات",
      description: "ما هو",
      known: "القيم الممكنة",
      remove: "إزالة الحقل {{n}}",
      add: "إضافة حقل",
      closed: "هذه الحقول فقط",
      help: "تظهر هذه الحقول للخطوات اللاحقة في قوائم الاختيار؛ ومع «هذه الحقول فقط» يُنبَّه إلى أي حقل مكتوب خطأً.",
      plainName: "الاسم الواضح",
      plainEn: "الاسم الواضح (بالإنجليزية)",
      plainAr: "الاسم الواضح (بالعربية)",
      codeName: "الاسم في الشيفرة",
      edit: "تعديل {{field}}",
      done: "تم",
      anyValue: "أي قيمة",
      mayBeEmpty: "قد يكون فارغًا",
      required: "يُعطى دائمًا (لا يستطيع الذكاء الاصطناعي إسقاطه)",
      requiredTag: "يُعطى دائمًا",
      internal: "داخلي (معلومات تنظيمية، مطويّة في القراءة)",
      internalGroup: "حقول داخلية ({{count}})",
      fromRun: "التعبئة من آخر تشغيل تجريبي",
    },
    fields: {
      outputField: "الاحتفاظ بهذا الحقل فقط من النتيجة",
      outputFieldHelp: "اتركه فارغاً للاحتفاظ بالنتيجة كاملة.",
      makes: "ما تُنتجه",
      makesHelp: "عرّف الحقول التي تنتجها هذه الخطوة (أو استخدم قيمة من تشغيل تجريبي) لتختارها الخطوات اللاحقة.",
      outputFormat: "صيغة الإجابة",
      outputFormatHelp: "اطلب من نموذج الذكاء الاصطناعي هذه الحقول بدلاً من نص حر؛ فتستطيع الخطوات اللاحقة استخدام كل حقل.",
      prompt: "ما يُسأل عنه نموذج الذكاء الاصطناعي",
      query: "ما يُبحث عنه",
      subject: "ما يراه المعتمِد",
      subjectPreview: "يرى المعتمِد: {{fields}}",
      answerType: "نوع الإجابة",
      answer: { text: "نص", number: "رقم", yes_no: "نعم أو لا", choice: "واحد من قائمة" },
      choices: "الخيارات",
      inputs: "ما يحصل عليه الوكيل الآخر",
      inputName: "مدخله",
      inputValue: "قيمة من هذا الوكيل",
      addInput: "إضافة مدخل",
      input: "ما يقرؤه نموذج القرار",
      sample: "شكل الحدث",
      sampleHelp: "الصق حدثاً نموذجياً (JSON). تصبح حقوله متاحة للخطوات باسم «الحدث الذي بدأه».",
      sampleInvalid: "هذا ليس JSON صالحاً.",
      sampleFields: "الحقول التي تستطيع الخطوات استخدامها",
      checks: "فحوص على حقول الإجابة",
      checksHelp: "يجب أن يتحقق كل فحص على البيانات النهائية للوكيل، مثل أن تكون حالة الإجابة ok.",
      addCheck: "إضافة فحص",
      approvalRules: "متى تنطبق قواعد الموافقة",
      prompts: "القيم التي يمكنك استخدامها",
      promptsAgent: "قيم من وكيل",
    },
    wizard: {
      amountField: "ما القيمة التي تمثّل المبلغ؟",
      amountFieldHelp: "يقارن حد الموافقة هذه القيمة. اختر المبلغ الذي يرسله الذكاء الاصطناعي إلى الإجراء.",
      amountRequest: "قيمة «amount» التي يرسلها الذكاء الاصطناعي إلى الإجراء",
      amountArg: "قيمة «{{name}}» التي يرسلها الذكاء الاصطناعي إلى «{{action}}»",
    },
    run: {
      seeData: "عرض ما مرّ عبر كل خطوة",
      show: "عرض بيانات التشغيل التجريبي",
      title: "من تشغيلك التجريبي",
      help: "ما مرّ عبر كل خطوة في تشغيلك التجريبي: البيانات الشخصية مخفية، والقيم الطويلة مختصرة، وتُحفظ لمدة {{hours}} ساعة. يُسجَّل اطلاعك عليها.",
      passed: "ما مرّ عبره (تشغيل تجريبي)",
      made: "ما أنتجته في التشغيل التجريبي",
      sent: "ما أُرسل إليها في التشغيل التجريبي",
      none: "لم يمرّ شيء هنا في التشغيل التجريبي.",
      masked: "البيانات الشخصية مخفية",
      truncated: "مختصرة",
      useShape: "استخدم هذا شكلاً لناتج الخطوة",
      unavailable: "لا يمكن عرض بيانات التشغيل التجريبي (تشغيلاتك التجريبية فقط في مرحلة التطوير، ولفترة محدودة).",
    },
    data: {
      maybe: "قد تكون فارغة",
      none: "لا شيء هنا بعد",
      typePath: "لا تطابق. اضغط Enter لاستخدام ما كتبته.",
      pick: "اختر قيمة من الخطوات السابقة",
      insert: "إدراج قيمة",
      insertFor: "إدراج قيمة من الخطوات السابقة في {{field}}",
      plainPreview: "بالأسماء البسيطة",
      unknownValue: "غير متاحة هنا",
      hint: {
        mustache: "اكتب {{ لإدراج قيمة من الخطوات السابقة.",
        brace: "اكتب { لإدراج إحدى قيم الخطوة.",
        state: "اكتب state. لإدراج قيمة من الخطوات السابقة.",
        prompt: "اكتب {{ لإدراج إحدى قيم الوكيل.",
      },
      type: { string: "نص", number: "رقم", integer: "عدد صحيح", boolean: "نعم أو لا", array: "قائمة", object: "مجموعة حقول", null: "فارغ", any: "أي شيء", date: "تاريخ", money: "مبلغ مالي" },
      fromStep: "الخطوة {{n}} · {{step}}",
      fromStart: "الطلب",
      eachItem: "كل عنصر",
      checks: "فحص البيانات",
      preview: "بكلمات بسيطة: {{text}}",
      arrowLabel: "اسم السهم ({{lang}})",
      arrowLabelHelp: "كلمات بسيطة تظهر على السهم، مثل «لم تُفهم المدينة».",
      show: "عرض الخطوة",
      saveBlocked: "يشير هذا الإصدار إلى بيانات غير موجودة",
      savedWithProblems: "حُفظ كمسودة. أصلح مشكلات البيانات قبل تقديمه.",
    },
    code: {
      title: "{{file}}",
      usedBy: "تستخدمه {{steps}}",
      usedByOne: "تستخدمه {{steps}}",
      notUsed: "لا تستخدمه أي خطوة",
      inline: "مكتوب داخل هذه الخطوة",
      step: "الخطوة {{n}}",
      edit: "تعديل",
      done: "تم",
      close: "إغلاق",
      editHelp: "أنت تعدّل ملف الوكيل. كل خطوة تستخدمه تحصل على التغيير؛ احفظ الوكيل للاحتفاظ به.",
      files: "ملفات الوكيل",
      filesHelp: "كود محفوظ مرة واحدة للوكيل كله؛ تستخدمه الخطوات باسمه.",
      noFiles: "لا توجد ملفات لهذا الوكيل.",
      size: "{{kb}} كيلوبايت",
      lines: "{{n}} سطراً",
      choose: "عرض {{file}}",
      usesFile: "يستخدم ملف الوكيل {{files}}",
    },
  },
};
